import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { getLoggedInUser, isAllowedToPlayVideo, setSession, updateUser } from '../utils/authUtils'

import { useTranslation } from 'react-i18next';
import { Alert, Button, Container, Form, Modal, Row } from 'react-bootstrap';
import fileDownload from 'js-file-download';
import styles from './account.module.css';

import userIcon from '../assets/images/perfil.svg';
import creditCard from '../assets/images/credit-card.svg';
import downloadButton from '../assets/images/download-bottom.svg';
import { axios, getAxiosConfig } from '../utils/apiUtils';

moment.locale('es');
moment.lang('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: 'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
  weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
  weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
  weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
}
);

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 12 },
};

const Account = () => {
  const { t, i18n } = useTranslation();
  const currentUser = getLoggedInUser();

  const [user, setUser] = useState();
  const [customer, setCustomer] = useState();
  const [notifications, setNotifications] = useState();
  const [subscription, setSubscription] = useState();
  const [goToHome, setGoToHome] = useState();
  const [goToSubscribe, setGoToSubscribe] = useState();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const refreshUserData = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/users/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((userResponse) => {
        setUser(userResponse.data);
        updateUser({
          user: userResponse.data
        });
      })
      .catch((userError) => {
        console.debug(userError);
      });
  };

  const refreshSubscription = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/subscription/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((subscriptionResponse) => {
        setSubscription(subscriptionResponse.data);
      })
      .catch((subscriptionError) => {
        console.debug(subscriptionError);
      });
  };

  const refreshCustomer = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/customer/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((customerResponse) => {
        setCustomer(customerResponse.data);
      })
      .catch((customerError) => {
        console.debug(customerError);
      });
  };

  const handleCreditCard = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/payments/creditcard`,
      {},
      getAxiosConfig(),
    )
    .then((creditCardResponse) => {
      window.location.replace(`${creditCardResponse.data.redirectTo}?token=${creditCardResponse.data.token}`)
      setCustomer(creditCardResponse.data);
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  const handleCreditCardAdd = () => {
    axios.post(
      `${process.env.REACT_APP_API_URL}/payments/creditcard`,
      {},
      getAxiosConfig(),
    )
    .then((creditCardResponse) => {
      window.location.replace(`${creditCardResponse.data.redirectTo}?token=${creditCardResponse.data.token}`)
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  const handleCreditCardDelete = () => {
    axios.delete(
      `${process.env.REACT_APP_API_URL}/payments/creditcard/`,
      getAxiosConfig(),
    )
    .then((creditCardResponse) => {
      setCustomer(creditCardResponse.data);
      setShowDeleteModal(false);
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  const handleUnsubscribe = () => {
    axios.delete(
      `${process.env.REACT_APP_API_URL}/payments/subscription/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
    .then((subscriptionResponse) => {
      updateUser({
        user: subscriptionResponse.data
      });
      setUser(subscriptionResponse.data);
      setShowCancelModal(false);
      refreshCustomer();
    })
    .catch((progressError) => {
      console.error("Couldn't send progress to chungungo servers > "+progressError.message);
    });
  };

  const handleInvoiceDownload = (invoiceId) => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/invoice/${invoiceId}`,
      {
        ...getAxiosConfig(),
        responseType: 'blob',
      }
    )
      .then((invoiceResponse) => {
        fileDownload(invoiceResponse.data, `boleta_chungungo_${invoiceId}.pdf`);
      })
      .catch((invoiceError) => {
        console.debug("Error downloading invoice");
      });
  };

  useEffect(
    () => {
      refreshUserData();
      refreshSubscription();
      refreshCustomer();
    },
    []
  );

  if (goToHome) {
    return <Redirect to="/seasons" push />;
  }

  if (goToSubscribe) {
    return <Redirect to="/account/subscribe/confirm" push />;
  }

  const {
    email,
    name
  } = getLoggedInUser().user;

  return (
    <section className="info-relevante">
      <div class="container"
        style={{paddingLeft: 32}}
      >
        <div class="row py-5">
          <div class="breadcrumb1 col-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb p-0">
                <li class="breadcrumb-item"><a href="/seasons">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  {t('account.title')}
                </li>
              </ol>
            </nav>
          </div>
          <div class="row" style={{
            width: '100%'
          }}>
            <div class="col-md-12">
              <div className={`row ${styles.payment}`}>
                <div class="col-lg-7 mb-4 mb-lg-0">
                  <div class="d-flex justify-content-between align-items-end mb-4">
                    <h2 class="m-0">Mi cuenta</h2>
                    <ul className={`${styles.accionesPago} m-0 list-inline`}>
                      <li class="list-inline-item">
                        <Button
                          variant="invisible"
                          className="text-danger"
                          onClick={(event) => { setSession(undefined); setGoToHome(true); }}
                        >
                          {t('account.button.logout')}
                        </Button>
                      </li>
                    </ul>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Nombre</label>
                        <input type="text" class="form-control" value={name} disabled />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Email</label>
                        <input type="text" class="form-control" value={email} disabled />
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.tipoSuscripcion} card card-body mt-4`}>
                    {user && isAllowedToPlayVideo() &&
                      <div class="d-lg-flex justify-content-between align-items-lg-center">
                        <div>
                          {user.roles.includes('subscriber') && 
                            <>
                              <p className="text-muted">Tu suscripción actual</p>
                              <p className={styles.suscripcionActual}>Chungungo</p>
                            </>
                          }
                          {!user.roles.includes('subscriber') && 
                            <p className="text-muted">Tienes una suscripción a Chungungo que es parte de tu programa de beneficios de la empresa o institución educacional en la que trabajas. Tendrás acceso a todo nuestro contenido mientras ese programa de beneficios esté vigente.</p>
                          }
                        </div>
                        <div>
                          {user.roles.includes('subscriber') && 
                            <Button
                              variant="primary"
                              onClick={evt => setShowCancelModal(true)}
                            >
                              Cancelar suscripción
                            </Button>
                          }
                        </div>
                      </div>
                    }
                    {user && !isAllowedToPlayVideo() &&
                      <div class="d-lg-flex justify-content-between align-items-lg-center">
                        <div>
                          <p style={{ whiteSpace: "pre-line" }}>
                            {t('account.notsubscribed.message')}
                          </p>
                          <Button
                            variant="primary"
                            className="mt-3"
                            onClick={evt => setGoToSubscribe(true)}
                          >
                            {t('account.notsubscribed.subscribe')}
                      </Button>
                        </div>
                      </div>
                    }
                  </div>

                  <Modal
                    show={showCancelModal}
                    onHide={evt => setShowCancelModal(false)}
                  >
                    <div class="modal-content">
                      <div class="modal-body">
                        <h5 class="modal-title mb-3" style={{ color: '#692700' }}>Confirmación De Cancelación De Suscripción</h5>
                        <p>Estás a punto de cancelar tu suscripción a Chungungo. No podrás acceder a la gran mayoría de las experiencias. ¿Deseas continuar? </p>
                      </div>
                      <div class="modal-footer">
                      <button type="button" class="btn btn-link" onClick={evt => setShowCancelModal(false)}>Seguir suscrito</button>
                        <button type="button" class="btn btn-outline-danger" onClick={evt => handleUnsubscribe()}>Si, quiero cancelar</button>
                      </div>
                    </div>
                  </Modal>

                  <Modal
                    show={showDeleteModal}
                    onHide={evt => setShowDeleteModal(false)}
                  >
                    <div class="modal-content">
                      <div class="modal-body">
                        <h5 class="modal-title mb-3" style={{ color: '#692700' }}>Confirmación de eliminación de tarjeta</h5>
                        <p>Eliminarás tu tarjeta del sistema, esto evitará que podamos cargar los siguientes pagos pudiendo perder tu subscripción a Chungungo. ¿Deseas continuar? </p>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-link" onClick={evt => setShowDeleteModal(false)}>Cancelar</button>
                        <button type="button" class="btn btn-outline-danger" onClick={evt => handleCreditCardDelete()}>Eliminar tarjeta</button>
                      </div>
                    </div>
                  </Modal>

                  <hr />
                  {customer &&
                    <>
                      <div class="d-flex justify-content-between align-items-center mb-4">
                        <h5>Datos de pago</h5>
                        {customer && customer.creditCardType &&
                          <ul className="accionesPago m-0 list-inline">
                            <li class="list-inline-item"><Button variant="no-border" onClick={() => handleCreditCard()}>Editar</Button></li>
                            <li class="list-inline-item"><Button variant="no-border" className="text-danger" onClick={() => setShowDeleteModal(true)}>Eliminar</Button></li>
                          </ul>
                        }
                      </div>
                      {customer && customer.creditCardType &&
                        <div class="d-flex justify-content-start mb-3">
                          <div>
                            <img src={creditCard} style={{ color: 'black' }} alt="" />
                          </div>
                          <div class="ml-4">
                            <span className={styles.cardNumber}> **** **** **** {customer.last4CardDigits}</span>
                            <div class="d-flex justify-content-between fw-bold">
                              <small class="text-muted">{customer.creditCardType.toUpperCase()}</small>
                            </div>
                          </div>
                        </div>
                      }
                      {(!customer || !customer.creditCardType) &&
                        <div>
                          <p>No tienes un medio de pago (tarjeta de crédito o débito) registrado.</p>
                          {subscription && subscription.status === 1 && user.roles.find(role => ['subscriber'].includes(role)) &&
                            <a href="#" class="btn btn-primary" onClick={() => handleCreditCard()}>Añadir tarjeta</a>
                          }
                        </div>
                      }

                      {subscription && subscription.status === 1 &&
                        <>
                          <p class="small">Próxima facturación: {moment(subscription.period_end).format('MMMM D, YYYY')}</p>
                        </>
                      }
                    </>
                  }

                </div>

                <div class="col-lg-4 offset-lg-1">
                  <div class="row">
                    <div class="col-lg-12 col-md-6 col-sm-12">
                      {subscription &&
                        <div className={`${styles.cardPayment} card card-body`}>
                          <h5 class="d-flex align-items-center"><img class="mr-2" src={creditCard} alt="" /> Últimas facturaciones</h5>
                          {subscription.invoices.map( (invoice) => (
                            <div className={`${styles.facturacion} d-flex justify-content-between align-items-center`}>
                              <p class="m-0">{moment(invoice.createdAt).format('MMMM D, YYYY')}</p>
                              <div>
                                <ul class="list-inline m-0">
                                  <li className={`list-inline-item ${styles.precio}`}>${invoice.amount}</li>
                                  <li class="list-inline-item"><Button variant="invisible" onClick={() => handleInvoiceDownload(invoice.id)}><img src={downloadButton} alt="" title="Descargar" /></Button></li>
                                </ul>
                              </div>
                            </div>
                          ))}
                          <a href="/account/invoices" className={`mt-2 ${styles.linkAnimado}`}>Ver todas</a>
                        </div>
                      }
                    </div>



                    <div class="col-lg-12 col-md-6 col-sm-12">
                      {notifications &&
                        <div class="card card-body cardPayment">
                          <h5 class="d-flex align-items-center"><img class="mr-2" src="images/alarm-bell.svg" alt="" /> Notificaciones</h5>
                          <div class="notificacion">
                            <p>Turpis in eu mi bibendum neque egestas congue quisque egestas</p>
                            <small>2 horas atrás</small>
                          </div>

                          <div class="notificacion">
                            <p>Turpis in eu mi bibendum neque egestas congue quisque egestas</p>
                            <small>2 horas atrás</small>
                          </div>

                          <a href="#" class="mt-2 linkAnimado">Ver todas</a>
                        </div>
                      }
                    </div>

                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default Account;